import React from 'react'

const Contact = () => {
  return (
    <>
    {/* // <div name='contact' className='w-full h-screen bg-[#0a192f] flex justify-center items-center p-4'>
    //     <form method='POST' action="https://getform.io/f/a699a1b2-f225-434e-b317-1fbbde8e006c" className='flex flex-col max-w-[600px] w-full'>
    //         <div className='pb-8'>
    //             <p className='text-4xl font-bold inline border-b-4 border-pink-600 text-gray-300'>Contact</p>
    //             <p className='text-gray-300 py-4'>// Submit the form below or shoot me an email - vutukuri.kumar192st.niituniversity.in</p>
    //         </div>
    //         <input className='bg-[#ccd6f6] p-2' type="text" placeholder='Name' name='name' />
    //         <input className='my-4 p-2 bg-[#ccd6f6]' type="email" placeholder='Email' name='email' />
    //         <textarea className='bg-[#ccd6f6] p-2' name="message" rows="10" placeholder='Message'></textarea>
    //         <button className='text-white border-2 hover:bg-pink-600 hover:border-pink-600 px-4 py-3 my-8 mx-auto flex items-center'>Let's Collaborate</button>
    //     </form>
    // </div> */}
{/* 
<section name='contact' className="text-gray-600 body-font relative bg-gray-500 py-24">
<div className="container px-5 mx-auto flex sm:flex-nowrap flex-wrap">
  <div className="bg-gray-300 rounded-lg overflow-hidden sm:mr-10 p-10 flex items-end justify-start relative">
    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1728.3603643342417!2d76.81525495465252!3d29.958710577752754!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390e38ae726f68e7%3A0x7d97866f8c459fe4!2sCentral%20Library%20Kuk!5e0!3m2!1sen!2sin!4v1712686508544!5m2!1sen!2sin" width="600" height="450" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
  </div>
  <div className="lg:w-1/3 md:w-1/2 bg-white flex flex-col md:ml-auto w-full md:py-8 mt-8 md:mt-0 px-10 rounded-lg">
    <h2 className="text-gray-900 text-lg mb-1 font-medium title-font">Contact Us</h2>
    <div className="bg-white relative flex flex-wrap py-6 rounded shadow-md mb-4">
      <div className="px-6">
        <h2 className="title-font font-semibold text-gray-900 tracking-widest text-xs">ADDRESS</h2>
        <p className="mt-1">Jawahar Lal Nehru Library, Kurukshetra University, Kurukshetra</p>
      </div>      
    </div>
    <div className="bg-white relative flex flex-wrap py-6 rounded shadow-md mb-4">       
      <div className="px-6">
        <h2 className="title-font font-semibold text-gray-900 tracking-widest text-xs">EMAIL</h2>
        <a className="text-indigo-500 leading-relaxed">haryanalibraryassociation@gmail.com</a>
        <h2 className="title-font font-semibold text-gray-900 tracking-widest text-xs mt-4">PHONE</h2>
        <p className="leading-relaxed">094666 94800</p>
      </div>
    </div>    
  </div> */}

<section name='contact' className="text-gray-600 body-font relative bg-gray-500 py-24">
  <div className="container mx-auto flex flex-wrap justify-center items-center px-5">
    
    {/* Map Box */}
    <div className="bg-gray-300 rounded-lg overflow-hidden mb-10 sm:mb-0 sm:mr-10 p-10 flex items-end justify-start relative w-full sm:w-auto">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1728.3603643342417!2d76.81525495465252!3d29.958710577752754!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390e38ae726f68e7%3A0x7d97866f8c459fe4!2sCentral%20Library%20Kuk!5e0!3m2!1sen!2sin!4v1712686508544!5m2!1sen!2sin"
        width="600"
        height="450"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>

    {/* Contact Form Box */}
    <div className="lg:w-1/3 md:w-1/2 w-full bg-white flex flex-col px-10 py-8 rounded-lg mt-8">
      <h2 className="text-gray-900 text-lg mb-1 font-medium title-font">Contact Us</h2>

      <div className="bg-white relative flex flex-wrap py-6 rounded shadow-md mb-4">
        <div className="px-6">
          <h2 className="title-font font-semibold text-gray-900 tracking-widest text-xs">ADDRESS</h2>
          <p className="mt-1">Jawahar Lal Nehru Library, Kurukshetra University, Kurukshetra</p>
        </div>
      </div>

      <div className="bg-white relative flex flex-wrap py-6 rounded shadow-md mb-4">
        <div className="px-6">
          <h2 className="title-font font-semibold text-gray-900 tracking-widest text-xs">Website</h2>
          <a className="text-indigo-500 leading-relaxed">https://hla.essnet.in/</a>
          <h2 className="title-font font-semibold text-gray-900 tracking-widest text-xs mt-4">EMAIL</h2>
          <a className="text-indigo-500 leading-relaxed">haryanalibraryassociation@gmail.com</a>
          <h2 className="title-font font-semibold text-gray-900 tracking-widest text-xs mt-4">PHONE</h2>
          <p className="leading-relaxed">094666 94800</p>
        </div>
      </div>
    </div>
    
  </div>
</section>


  {/* <div className="lg:w-1/3 md:w-1/2 bg-white flex flex-col md:ml-auto w-full md:py-8 mt-8 md:mt-0 px-10 rounded-lg">
    <h2 className="text-gray-900 text-lg mb-1 font-medium title-font">Contact / Feedback Form</h2>
    <div className="relative mb-4">
      <label for="name" className="leading-7 text-sm text-gray-600">Name</label>
      <input type="text" id="name" name="name" className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"/>
    </div>
    <div className="relative mb-4">
      <label for="email" className="leading-7 text-sm text-gray-600">Email</label>
      <input type="email" id="email" name="email" className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"/>
    </div>
    <div className="relative mb-4">
      <label for="message" className="leading-7 text-sm text-gray-600">Message</label>
      <textarea id="message" name="message" className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 h-32 text-base outline-none text-gray-700 py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out"></textarea>
    </div>
    <button className="opacity-50 cursor-not-allowed text-white bg-indigo-500 border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded text-lg">Submit</button>
  </div> 
</div>
</section>*/} 
</>
  )
}

export default Contact